import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'fee'
})
export class FeePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: number|null, estimateFee: number|null): any {
    if (value === 0 || value === null) {
      if (!(estimateFee === 0 || estimateFee === null || estimateFee === undefined)) {
        let result = `<span style="color: var(--light-text-color);">(予)${estimateFee}</span>`
        return this.domSanitizer.bypassSecurityTrustHtml(result);
      }
      return null;
    } else {
      return value;
    }
  }
}
